import { Button, Flex, Text } from '@mantine/core';
import { IconArrowsSort } from '@tabler/icons-react';
import * as React from 'react';

import { SORT_CONFIG, type SortBy } from './config';

import s from './SearchTreeTopLine.module.scss';

type Props = {
  totalDocuments: number;
  sortBy?: SortBy;
  onSortChange?: (sortBy: SortBy) => void;
};

const SearchTreeTopLine: React.FC<Props> = ({ totalDocuments, sortBy, onSortChange }) => {
  const handleToggle = React.useCallback(() => {
    if (!sortBy || !onSortChange) {
      return;
    }

    onSortChange(SORT_CONFIG[sortBy].next);
  }, [sortBy, onSortChange]);

  return (
    <div className={s.root}>
      <Flex justify="space-between" align="center">
        <Text size="xs" fw="bolder">
          Найдено {totalDocuments} документов
        </Text>
        {sortBy !== undefined && onSortChange !== undefined && (
          <Button
            size="xs"
            variant="light"
            leftSection={<IconArrowsSort size={12} />}
            onClick={handleToggle}
            miw={153}
            justify="flex-start"
            classNames={{
              root: s['root__sort-button'],
              inner: s['root__sort-button-inner'],
              label: s['root__sort-button-label'],
            }}
          >
            <span key={sortBy} className={s['root__sort-label']}>
              {SORT_CONFIG[sortBy].label}
            </span>
          </Button>
        )}
      </Flex>
    </div>
  );
};

export default React.memo(SearchTreeTopLine);
